import React, { useState, useEffect } from "react";

const Section2 = ({ url,currentColor }) => {
  const [displayDots, setDisplayDots] = useState(true);
  const [displayText, setDisplayText] = useState("none");
  const [buttonText, setButtonText] = useState("Read More");

  const handleButtonClick = () => {
    if (displayDots) {
      setDisplayDots(false);
      setButtonText("Read Less");
      setDisplayText("block");
    } else {
      setDisplayDots(true);
      setButtonText("Read More");
      setDisplayText("none");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 2500) {
        setDisplayText("none");
      } else {
        setDisplayText("block");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial display state based on window width

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="about-section-2">
      <div className="container sect-2-container">
        <div className="row sect-2-row">
          <div className="col-lg-5 col-md-5 col-sm-12 left-section">
            <img
              loading="lazy"
              src={url + "images/about-us/2.jpg"}
              className="left-img"
              alt="About our Services"
              data-aos="fade-right"
              data-aos-duration="1000"
            />
          </div>
          <div className="col-lg-7 col-md-7 col-sm-12 right-section">
            <div className="txt">
              <h5 data-aos="fade-left" data-aos-duration="1000">
                <strong style={{ color: "#fcb61d", fontSize: "22px" }}>What We Do </strong>
                <br />
                <br />
                <br />
                <strong style={{ color: "#fcb61d" }}>
                  Development
                </strong>
                <br />
                <br />
                  Custom-built web and mobile applications, SaaS platforms, MVPs, ERP extensions, and cloud-based systems designed for scalability, security, and performance.
                <br />
                <br />
                <br />
                <strong style={{ color: "#fcb61d" }}>AI & Automation</strong>
                <br />
                <br />
                Workflow automation, predictive analytics, AI-powered decision support systems, and intelligent integrations that reduce manual effort and enable data-driven operations.

                <br />
                <br />
                <br />
                <strong style={{ color: "#fcb61d" }}>Design</strong>
                <br />
                <br />
                User-centric UI/UX design and digital experiences that align functionality with brand identity, ensuring usability, consistency, and engagement across platforms.

                <br />
                <br />
                <br />
                <strong style={{ color: "#fcb61d" }}>
                    Marketing

                  </strong>
                  <br />
                  <br />
                  Performance-focused digital marketing, social media strategy, and branding initiatives that help businesses build visibility, generate qualified leads, and strengthen their digital presence.

                <br />
                {/* <span id="dots"></span>
                <span id="more" style={{ display: displayText }}>

                  <br />
                  <br />
                </span> */}
                {/* {window.innerWidth < 2500 && (
                  <button
                    onClick={handleButtonClick}
                    id="myBtn"
                    className="myBtn"
                  >
                    {buttonText}
                  </button>
                )} */}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section2;
